import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { useTranslation } from 'react-i18next';

export const ModalLegalDocuments = ({userCountry, visible, onHide, onAccept }) => {
    const { t, i18n } = useTranslation();
    const [eulaAccepted, setEulaAccepted] = useState(false);
    const [dataAccessAccepted, setDataAccessAccepted] = useState(false);

    // Efecto para deshabilitar el scroll del body cuando el modal esté visible
    useEffect(() => {
        if (visible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        // Cleanup: restaurar el scroll cuando el componente se desmonte
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [visible]);

    const handleContinue = () => {
        if (eulaAccepted && dataAccessAccepted) {
            onAccept();
            onHide();
        }
    };

    const isDisabled = !eulaAccepted || !dataAccessAccepted;

    return (
        <>
            {visible && (
                <div 
                    className="fixed top-0 left-0 w-full h-full bg-white flex align-items-center justify-content-center"
                    style={{ 
                        zIndex: 9999,
                        position: 'fixed',
                        backgroundColor: 'white'
                    }}
                >
                    <div 
                        className="bg-white border-round-2xl shadow-8 p-3 m-3 pt-4 pb-4"
                        style={{ 
                            maxWidth: '450px',
                            maxHeight: '90vh',
                            overflow: 'auto'
                        }}
                    >
                        {/* Header */}
                        <div className="flex align-items-center gap-2 mb-2">
                            <span className="font-bold text-900 text-xl">{t('legal.new_legal_documents')}</span>
                        </div>
                        
                        <div className="flex flex-column gap-2">
                            {/* EULA Section */}
                            <div className="legal-section">
                                <h3 className="text-lg font-bold text-900 mb-2">{t('legal.eula')}</h3>
                                {/* 
                                <p className="text-600 mb-3 line-height-3">
                                    {t('legal.eula_description')}
                                </p>
                                */}
                                <a 
                                    href={`https://nematool.com/legal/${userCountry.toUpperCase()}/Nematool-UserLicenseAgreement.pdf`}
                                    className="text-primary no-underline mb-2 inline-block"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('legal.link_to_eula')}
                                </a>
                                <div className="flex align-items-center gap-2">
                                    <Checkbox
                                        inputId="eula-checkbox"
                                        checked={eulaAccepted}
                                        onChange={(e) => setEulaAccepted(e.checked)}
                                    />
                                    <label htmlFor="eula-checkbox" className="text-900">
                                        {t('legal.accept_eula_changes')}
                                    </label>
                                </div>
                            </div>

                            {/* Data Access Agreement Section */}
                            <div className="legal-section">
                                <h3 className="text-lg font-bold text-900 mb-2">{t('legal.data_access_agreement')}</h3>
                                {/* 
                                <p className="text-600 mb-3 line-height-3">
                                    {t('legal.data_access_description')}
                                </p>
                                */}
                                <a 
                                    href={`https://nematool.com/legal/${userCountry.toUpperCase()}/Nematool-DataAccessAgreement.pdf`}
                                    className="text-primary no-underline mb-2 inline-block"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('legal.link_to_data_access')}
                                </a>
                                <div className="flex align-items-center gap-2">
                                    <Checkbox
                                        inputId="data-access-checkbox"
                                        checked={dataAccessAccepted}
                                        onChange={(e) => setDataAccessAccepted(e.checked)}
                                    />
                                    <label htmlFor="data-access-checkbox" className="text-900">
                                        {t('legal.accept_data_access')}
                                    </label>
                                </div>
                            </div>

                            {/* Continue Button */}
                            <div className="flex justify-content-center mt-4">
                                <Button
                                    label={t('legal.continue')}
                                    className={`p-button-lg w-full ${isDisabled ? 'p-button-secondary' : ''}`}
                                    onClick={handleContinue}
                                    disabled={isDisabled}
                                    style={{
                                        backgroundColor: isDisabled ? '#ccc' : '#8BC34A',
                                        borderColor: isDisabled ? '#ccc' : '#8BC34A',
                                        color: 'white'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};